import { render } from "./app-format-time.vue?vue&type=template&id=40c88869&ts=true"
import script from "./app-format-time.vue?vue&type=script&lang=ts"
export * from "./app-format-time.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__